import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import pt from "./locales/pt.json";

export const SUPPORTED_LANGUAGES = [
    { code: "en", name: "English",    native: "English",    flag: "🇬🇧" },
    { code: "fr", name: "French",     native: "Français",   flag: "🇫🇷" },
    { code: "es", name: "Spanish",    native: "Español",    flag: "🇪🇸" },
    { code: "ar", name: "Arabic",     native: "العربية",    flag: "🇸🇦", rtl: true },
    { code: "pt", name: "Portuguese", native: "Português",  flag: "🇧🇷" },
];

const RTL_CODES = new Set(SUPPORTED_LANGUAGES.filter((l) => l.rtl).map((l) => l.code));

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr },
            es: { translation: es },
            ar: { translation: ar },
            pt: { translation: pt },
        },
        fallbackLng: "en",
        supportedLngs: SUPPORTED_LANGUAGES.map((l) => l.code),
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator"],
            lookupLocalStorage: "wta_lang",
            caches: ["localStorage"],
        },
    });

// Keep <html lang="…" dir="ltr|rtl"> in sync so CSS + screen readers behave
function applyLangToDocument(lng) {
    const code = (lng || "en").split("-")[0];
    const html = document.documentElement;
    html.setAttribute("lang", code);
    html.setAttribute("dir", RTL_CODES.has(code) ? "rtl" : "ltr");
}
applyLangToDocument(i18n.language);
i18n.on("languageChanged", applyLangToDocument);

export default i18n;
